var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-upload" },
    [
      _c(
        "el-form",
        [
          _c(
            "el-upload",
            {
              ref: "upload",
              class: "upload-" + _vm.fileList.length,
              attrs: {
                limit: _vm.limitNumber,
                action: "",
                accept: "image/*",
                "before-upload": _vm.beforeAvatarUpload,
                "http-request": _vm.uploadFile,
                "list-type": "picture-card",
                "auto-upload": true,
                "file-list": _vm.fileList,
                "on-preview": _vm.handlePictureCardPreview,
                "on-exceed": _vm.handleExceed,
                "before-remove": _vm.beforeRemove,
              },
            },
            [_c("i", { staticClass: "el-icon-plus avatar-uploader-icon" })]
          ),
          _c(
            "el-dialog",
            {
              attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  width: "100%",
                  fit: "contain",
                  src: _vm.dialogImageUrl,
                  alt: "",
                },
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }